<template>
    <div class="sticky-md-top">
        <ul class="list-group mb-3">
            <li
                @click="emitter.emit('changeActiveTab', 'understanding-your-tyres')"
                class="list-group-item cursor-pointer text-underline"
                :class="activeTab == 'understanding-your-tyres' ? 'active' : ''"
            >
                Understanding your tyres
            </li>
            <li
                @click="emitter.emit('changeActiveTab', 'tyre-labelling')"
                class="list-group-item cursor-pointer text-underline"
                :class="activeTab == 'tyre-labelling' ? 'active' : ''"
            >
                Tyre Labelling
            </li>
            <li
                @click="emitter.emit('changeActiveTab', 'are-your-tyres-legal')"
                class="list-group-item cursor-pointer text-underline"
                :class="activeTab == 'are-your-tyres-legal' ? 'active' : ''"
            >
                Are your tyres legal?
            </li>
            <li
                @click="emitter.emit('changeActiveTab', 'all-inclusive')"
                class="list-group-item cursor-pointer text-underline"
                :class="activeTab == 'all-inclusive' ? 'active' : ''"
            >
                What does 'All Inclusive' mean?
            </li>
            <li class="list-group-item cursor-pointer">
                <a href="/tyre-safety" class="d-block text-black" title="Tyre Safety">Tyre Safety</a>
            </li>
            <li class="list-group-item cursor-pointer">
                <a href="/faq" class="d-block text-black" title="FAQ's">FAQ's</a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['activeTab']
        
    }
</script>

<style lang="scss" scoped>
    .sticky-md-top {
        top: 10px;
        z-index: 5;
    }
</style>